import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToggleDisplayRoleDirective } from './toggle-display-role/toggle-display-role.directive';

@NgModule({
    declarations: [ToggleDisplayRoleDirective],
    exports: [ToggleDisplayRoleDirective],
    imports: [CommonModule],
})
export class AuthDirectivesModule {}
